import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/nav/Navbar";
import Footer from "./components/footer/Footer";
import { LandingPage, Spend, Purchase } from "./pages";

const App = () => {
	return (
		<div>
			<BrowserRouter>
				<Navbar />
				<Routes>
					<Route index element={<LandingPage />} />
					<Route path="spend" element={<Spend />} />
					<Route path="purchase" element={<Purchase />} />
				</Routes>
				<Footer />
			</BrowserRouter>
		</div>
	);
};

export default App;
